import type { InterventionBreadcrumbProps } from "./intervention-breadcrumb.type";

import AncestorsBreadcrumb from "@/modules/ancestors/ancestors-breadcrumb";

const InterventionBreadcrumb = ({
  intervention,
  ...options
}: InterventionBreadcrumbProps) => {
  return (
    <AncestorsBreadcrumb {...options} ancestors={intervention?.ancestors} />
  );
};

export default InterventionBreadcrumb;
